import { listenToEventSync } from '../util/listen_to_event.js';
import { addSwipeLeft } from '../util/util.js';
import { LocViewBase } from './loc_view_base.js';

const landscapeMobile = `screen and (max-height:640px) and (min-width:480px) and (orientation:landscape)`;

class LocViewRegular extends LocViewBase {
  static markupType = 'regular';
  static tagName = 'loc-view-regular';

  initialize() {
    super.initialize();

    // Swipe down on the cover collapses the panel (mobile).
    listenToEventSync(this.coverContainer, 'touchstart', ev => {
      if (ev.changedTouches.length == 1) {
        this.#touchStartX = ev.changedTouches[0].clientX;
        this.#touchStartY = ev.changedTouches[0].clientY;
      }
    });
    listenToEventSync(this.coverContainer, 'touchmove', ev => {
      if (ev.changedTouches.length == 1) {
        // Suppress pull-to-refresh on mobile chrome
        ev.preventDefault();
      }
    });

    listenToEventSync(this.coverContainer, 'touchend', ev => {
      if (ev.changedTouches.length == 1) {
        // Swipe down to collapse.
        if (
          Math.abs(ev.changedTouches[0].clientX - this.#touchStartX) <
          ev.changedTouches[0].clientY - this.#touchStartY
        ) {
          this.fireCollapse();
        }
      }
    });

    // Swipe left to close the panel in landscape mode (mobile).
    addSwipeLeft(this, () => {
      if (window.matchMedia(landscapeMobile).matches) {
        this.fireClose();
      }
    });
  }

  #touchStartX;
  #touchStartY;
}

LocViewRegular.defineCustomElement();

export { LocViewRegular };
